export const FARMER_CUSTOMER_ATTRIBUTE_ENUM = {
  NUM_FREE_DEVICES: 'num_free_devices',
  SUBSCRIPTIONS: 'subscriptions'
};

export const MANAGER_CUSTOMER_ATTRIBUTE_ENUM = {
  VIA_RESELLER: 'viaReseller'
};

export const FARMER_CUSTOMER_TELEMETRY_ENUM = {
  CURRENT_MIN_TEMPERATURE: 'current_min_temperature',
  CURRENT_MAX_TEMPERATURE: 'current_max_temperature',
  CURRENT_AVG_TEMPERATURE: 'current_avg_temperature',
  CURRENT_MIN_HUMIDITY: 'current_min_humidity',
  CURRENT_MAX_HUMIDITY: 'current_max_humidity',
  CURRENT_AVG_HUMIDITY: 'current_avg_humidity'
};
